export default "__VITE_ASSET__752a7b1c__"